
import { defineComponent, ref } from 'vue'
import { User } from "../../models/User";
import { ScopeDefinition, ScopeDefinitions } from "../../models/ScopeDefinition";
import { FlowData } from "../../models/FlowData";
import { mapGetters } from "vuex";

export default defineComponent({
    name: "Login",
    computed: {
        ...mapGetters({
            User: "userstate/getUser",
        }),
    },
    props: {
        scope: { type: String, default: "" },
        initiator: String,
        client_id: String,
        response_type: String,
        redirect_uri: String,
        state: String,
        domain: { type: String, default: "" },
    },
    setup() {
        let selectedScopes = ref(new Array<string>());
        let scopes = ref(new Array<ScopeDefinition>());

        scopes.value.push(ScopeDefinitions.leads);
        scopes.value.push(ScopeDefinitions.broker);

        return {
            selectedScopes, scopes
        }
    },
    data() {
        return {
            promptForScopes: false,
            selectableDomainNames: Array<String>(),
            stage: "waiting",
            errorText: "",
            waiting: false,
            username: "",
            password: "",
            domainName: this.domain,
            flowData: new FlowData()
        }
    },
    beforeMount() {
        if (this.initiator === "selfserve" ||(this.scope && this.scope.includes("passport"))) {
            this.flowData.scope = this.scope;
            this.stage = "credentials";
        } 
        else {
            this.stage = "scopes";
        }
    },
    methods: {
        actionCountText() {
            const scopeCount = this.scope.split(" ").length;
            if (scopeCount === 1) return "1 scope";
            return scopeCount + " scopes";
        },

        showScopes() {
            this.stage = "scopes";
        },

        acceptScopes() {
            this.stage = "credentials";
        },

        login() {
            this.stage = "waiting";
            this.errorText = "";

            this.flowData.client_id = this.client_id ? this.client_id : "";
            this.flowData.response_type = this.response_type ? this.response_type : "";
            this.flowData.redirect_uri = this.redirect_uri ? this.redirect_uri : "";
            this.flowData.scope = this.scope ? this.scope : "";
            this.flowData.state = this.state ? this.state : "";
            const userObj = {
                username: this.username,
                domainName: this.domainName,
                password: this.password,
                flowData: this.flowData,
                webUrl: window.location.host,
            };
            if (this.username.endsWith("@cincpro.com") && this.password === "") {
                this.$store.state.axiosService.OktaLogin(userObj)
                .then((response:any)=> {
                    window.location.href = response.redirect_uri;
                })
                return;
            }
            this.$store.state.axiosService.Login(userObj)
            .then((response: any) => {
                if (response && response.domains) {
                    this.selectableDomainNames = response.domains;
                    setTimeout(() => (this.stage = "domain"), 1000);
                } 
                else {
                    if (response) {
                        if (response.user && response.user.firstName && response.user.lastName) {
                            this.$store.dispatch("userstate/setUser", new User(response.user.firstName, response.user.lastName, response.user.domainName ?? "", true));
                        }

                        if (response.redirect_uri) {
                            window.location.assign(response.redirect_uri);
                        }

                        return;
                    }

                    this.$router.push({ name: "Intro" });
                }
            })
            .catch((response: Error) => {
                setTimeout(() => {
                this.stage = "credentials";
                this.errorText = response.message;
                this.domainName = "";
                }, 1000);
                console.log("Error logging in.");
            });
        }
    }
})
